var autoslash = autoslash || {};

autoslash.createNamespace = function (namespace) {
    "use strict";
    var nsparts = namespace.split(".");
    var parent = autoslash;

    // we want to be able to include or exclude the root namespace 
    // So we strip it if it's in the namespace
    if (nsparts[0] === "autoslash") {
        nsparts = nsparts.slice(1);
    }

    // loop through the parts and create 
    // a nested namespace if necessary
    for (var i = 0; i < nsparts.length; i++) {
        var partname = nsparts[i];
        // check if the current parent already has 
        // the namespace declared, if not create it
        if (typeof parent[partname] === "undefined") {
            parent[partname] = {};
        }
        // get a reference to the deepest element
        // in the hierarchy so far
        parent = parent[partname];
    }
    // the parent is now completely constructed 
    // with empty namespaces and can be used.
    return parent;
};

autoslash.libraries = [];

$(function () {
    "use strict";
    autoslash.initialize($(document.documentElement));
});

autoslash.register = function (library) {
    "use strict";
    autoslash.libraries.push(library);
}

autoslash.initialize = function(element) {
    "use strict";
    for (var index = 0; index < autoslash.libraries.length; ++index) {
        if (typeof (autoslash.libraries[index].initialize) == "function") {
            autoslash.libraries[index].initialize(element);
        }
    }
}